// extracted by mini-css-extract-plugin
var _1 = "#68914d";
var _2 = "#9cc681";
var _3 = "#8ab46f";
var _4 = "asinLink___EoDaZ";
var _5 = "8px";
var _6 = "6px";
var _7 = "8px";
var _8 = "0 1px 1px 0 rgba(0,0,0,.02) inset";
var _9 = "0 8px 8px -4px rgba(0,0,0,.03),0 16px 24px -4px rgba(0,0,0,.08)";
var _a = "10px";
var _b = "#e8e8e8";
var _c = "16px 24px";
var _d = "#38aa73";
var _e = "#956c22";
var _f = "#2988bd";
var _10 = "#eee";
var _11 = "color-default___HQfIG";
var _12 = "color-inherit___VvYfL";
var _13 = "color-muted___JwEac";
var _14 = "#c4842d";
var _15 = "#b8567c";
var _16 = "#8b6e4e";
var _17 = "#5889c2";
var _18 = "#4e8a8a";
var _19 = "#6a8a3e";
var _1a = "#7b5ea7";
var _1b = "#4a6fa5";
var _1c = "#3a8a6e";
var _1d = "#c25b4e";
var _1e = "#fafbfc";
var _1f = "#1e3050";
var _20 = "#293d62";
var _21 = "#fafbfc";
var _22 = "rgba(0,0,0,.12)";
var _23 = "#d9d9d9";
var _24 = "rgba(5,5,5,.1)";
var _25 = "#eaf2fc";
var _26 = "rgba(0,0,0,.65)";
var _27 = "#ebebeb";
var _28 = "#068467";
var _29 = "rgba(6,132,103,.1)";
var _2a = "#dc4949";
var _2b = "rgba(220,73,73,.1)";
var _2c = "#787c81";
var _2d = "#d6d9dc";
var _2e = "#f3f5f7";
var _2f = "#73c9b2";
var _30 = "linear-gradient(180deg, #73C9B2 0%, #B8E7DA 100%)";
var _31 = "#b8e7da";
var _32 = "#5357f8";
var _33 = "rgb(14.3921787709,19.9877094972,245.2078212291)";
var _34 = "rgb(249.6189944134,249.7441340782,254.7810055866)";
var _35 = "#f7f8f9";
var _36 = "#edeeef";
var _37 = "#7b8996";
var _38 = "#ededed";
var _39 = "#f4f5f7";
var _3a = "#fbfbfc";
var _3b = "rgba(0,0,0,.75)";
var _3c = "rgba(171.2567039106,172.4612273574,220.9432960894,.95)";
var _3d = "rgba(0,0,0,.3)";
var _3e = "rgba(0,0,0,.5)";
var _3f = "rgba(0,0,0,.4)";
var _40 = "rgba(0,0,0,.95)";
var _41 = "rgba(0,0,0,.65)";
var _42 = "rgba(0,0,0,.85)";
var _43 = "20px";
var _44 = "#f41e28";
var _45 = "1063px";
var _46 = "rgba(227,89,86,.2)";
var _47 = "#e35956";
var _48 = "16px 24px";
var _49 = "28px";
var _4a = "32px";
var _4b = "18px";
var _4c = "14px";
var _4d = "14px";
var _4e = "15px";
var _4f = "12.6px";
var _50 = "11px";
var _51 = "20px";
var _52 = "28px";
var _53 = "700";
var _54 = "200";
var _55 = "300";
var _56 = "500";
var _57 = "400";
var _58 = "600";
var _59 = "hsla(0,0%,100%,.2)";
var _5a = "#ccc";
var _5b = "49px";
var _5c = "5px";
var _5d = "#5357f8";
var _5e = "rgba(0,0,0,.4)";
var _5f = "#fafafa";
var _60 = "hsla(0,0%,100%,.9)";
var _61 = "15px";
var _62 = "20px";
var _63 = "24px";
var _64 = "hsla(0,0%,100%,.6)";
var _65 = "#7e7eff";
var _66 = "hsla(0,0%,100%,.7)";
var _67 = "hsla(0,0%,100%,.3)";
var _68 = "hsla(0,0%,100%,.575)";
var _69 = "60px";
var _6a = "208px";
var _6b = "rgba(82,196,26,.2)";
var _6c = "#52c41a";
var _6d = "12px";
var _6e = "20px";
var _6f = "rgba(250,173,20,.2)";
var _70 = "#faad14";
var _71 = "#fff";
var _72 = "hsla(0,0%,100%,.2)";
export { _1 as "actionButtonColorDark", _2 as "actionButtonColorLight", _3 as "actionButtonColorMedium", _4 as "asinLink", _5 as "borderRadiusCard", _6 as "borderRadiusMain", _7 as "borderRadiusSurface", _8 as "boxShadowInnerXs", _9 as "boxShadowXl", _a as "btnRightMargin", _b as "cardBorderColor", _c as "cardPadding", _d as "changeSetCompletedColor", _e as "changeSetManuallyChangesProposed", _f as "changeSetScheduledChangesProposed", _10 as "chipBackground", _11 as "color-default", _12 as "color-inherit", _13 as "color-muted", _14 as "colorAccentAmber", _15 as "colorAccentBerry", _16 as "colorAccentBrown", _17 as "colorAccentCornflower", _18 as "colorAccentCyan", _19 as "colorAccentOlive", _1a as "colorAccentPurple", _1b as "colorAccentSteelBlue", _1c as "colorAccentTeal", _1d as "colorAccentTerracotta", _1e as "colorBackgroundMain", _1f as "colorBackgroundSidebar", _20 as "colorBackgroundSidebarHover", _21 as "colorBackgroundTabs", _22 as "colorBorderContainer", _23 as "colorBorderMain", _24 as "colorBorderSecondary", _25 as "colorDeltaCyanBlueBg", _26 as "colorDeltaGray", _27 as "colorDeltaGrayBg", _28 as "colorDeltaGreen", _29 as "colorDeltaGreenBg", _2a as "colorDeltaRed", _2b as "colorDeltaRedBg", _2c as "colorDetailsFieldText", _2d as "colorDetailsIcon", _2e as "colorDetailsTagBg", _2f as "colorMint", _30 as "colorMintGradient", _31 as "colorMintLight", _32 as "colorPrimary", _33 as "colorPrimaryHover", _34 as "colorPrimaryLightened", _35 as "colorTableHeadBg", _36 as "colorTableHeadBgHover", _37 as "colorTableHeadSubtitle", _38 as "colorTableRowBorder", _39 as "colorTableTextBg", _3a as "colorTableTotalRowBg", _3b as "colorTextBase", _3c as "colorTextDisabled", _3d as "colorTextExtraLight", _3e as "colorTextLight", _3f as "colorTextLighter", _40 as "colorTextMainHeading", _41 as "colorTextMuted", _42 as "colorTextPrimary", _43 as "contentHorizPadding", _44 as "dangerColor", _45 as "dashboardPdfContentWidth", _46 as "errorBackcolor", _47 as "errorColor", _48 as "filterPanelPadding", _49 as "filtersDefaultHeight", _4a as "filtersTallHeight", _4b as "fontSizeLarge", _4c as "fontSizeMain", _4d as "fontSizeMedium", _4e as "fontSizePlus", _4f as "fontSizeSmaller", _50 as "fontSizeSmallest", _51 as "fontSizeXLarge", _52 as "fontSizeXxLarge", _53 as "fontWeightBold", _54 as "fontWeightExtraLight", _55 as "fontWeightLight", _56 as "fontWeightMediumBold", _57 as "fontWeightNormal", _58 as "fontWeightSemiBold", _59 as "ghostWhite", _5a as "grayBackgroundColor", _5b as "headerHeight", _5c as "iconHorizontalMargin", _5d as "linkColor", _5e as "linkColorMuted", _5f as "popoverHeaderColor", _60 as "popoverMaskColor", _61 as "rowPadding", _62 as "ruleInnerGutters", _63 as "ruleSideGutters", _64 as "sideMenuIconColor", _65 as "sideMenuIconSelectedColor", _66 as "sideMenuItemColor", _67 as "sideMenuScrollbarThumbColor", _68 as "sideMenuSubmenuItemColor", _69 as "sidebarCollapsedWidth", _6a as "sidebarWidth", _6b as "successBackcolor", _6c as "successColor", _6d as "tableHeaderVerticalPadding", _6e as "tableHorizPadding", _6f as "warningBackcolor", _70 as "warningColor", _71 as "whiteColor", _72 as "whiteDividerColor" }
